import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface UserStateState {
  userDetails: User;
}

export interface User {
  Token: string;
  MemberId: string;
  Expiration: string;
  IsNewApplicant: boolean;
  MembershipTypeId: number;
}

const initialState: UserStateState = {
  userDetails: {
    Token: "",
    MemberId: "",
    Expiration: "",
    IsNewApplicant: false,
    MembershipTypeId: 0,
  },
};

export const useAuthSlice = createSlice({
  name: "userDetails",
  initialState,
  reducers: {
    updateUserDetails: (state, action: PayloadAction<User>) => {
      state.userDetails = action.payload;
    },
  },
});

export const { updateUserDetails } = useAuthSlice.actions;

export default useAuthSlice.reducer;
